import { EChartOption } from 'echarts';
import ReactEcharts from 'echarts-for-react';
import React from 'react';
import { IAxisSetting, IConfig, IPens } from '../../index';
// import './graph.css';

export interface IRefs {
    chartRef: React.RefObject<any>;
    scrollRefX: React.RefObject<HTMLDivElement>;
    scrollRefY: React.RefObject<HTMLDivElement>;
}

interface IGraph {
    refs: IRefs;
    data: any;
    pens: IPens[];
    config: IConfig;
    parentID: string;
    playStopDisplay: boolean;
    newSeriesPoints: any[];
    groupPensInfo?: any[];
    selectedPen?: any;
    echarts_react?: any;
    notMerge?: boolean;
    calbacUpdateRow?: any;
    id?: string;
    resetData: boolean;
    onChartRef: (ref: any) => void;
    SetInterval: (check: boolean) => void;
}

export interface TrendHandle {
    handleReduceTimeAxis?: () => void;
}

const GroupGraph = React.forwardRef<TrendHandle, IGraph>((props, forwardedRef) => {
    const {
        refs,
        data,
        pens,
        config,
        parentID,
        groupPensInfo,
        echarts_react,
        notMerge,
        calbacUpdateRow,
        id,
        onChartRef
    } = props;

    const dataline = {
        name: '',
        type: 'line',
        step: false,
        symbol: 'none',
        showSymbol: true,
        symbolSize: 3,
        lineStyle: {
            color: '#000',
            width: 2,
            shadowColor: 'rgba(102, 195, 208, 0.56)',
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowOffsetY: 4
        },
        large: true,
        data: [],
        encode: { x: 0, y: 1 },
        label: { show: false },
        animation: false,
        markPoint: {}
    };

    const option_def: EChartOption = {
        grid: {
            top: 10,
            right: 0,
            bottom: 40,
            left: 45,
            show: true,
            backgroundColor: '#f0f9fb',
            borderWidth: 0
        },
        tooltip: {
            trigger: 'axis',
            backgroundColor: 'rgba(255, 255, 255, 0.45)',
            position: function (pos: any, params: any, el: any, elRect: any, size: any) {
                var obj: any = { top: 10 };
                obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 30;
                return obj;
            },
            formatter: function (params: any) {
                const usedSeriesNames: { [key: string]: boolean } = {};

                params.sort(function (a: any, b: any) {
                    return parseInt(b.value) - parseInt(a.value);
                });

                let output = '<b></b><br/>';

                if ((props.config.settings.chart.xAxis as IAxisSetting)?.type == 'time') {
                    let d = new Date(params[0].value[0]);
                    var datestring =
                        d.getDate() +
                        '/' +
                        (d.getMonth() + 1) +
                        '/' +
                        d.getFullYear() +
                        ' ' +
                        d.getHours() +
                        ':' +
                        d.getMinutes() +
                        ':' +
                        d.getSeconds();
                    output = '<b>' + datestring + '</b><br/>';
                } else {
                    output = '<b>' + params[0].value[0] + '</b><br/>';
                }

                for (let ipar = 0; ipar < params.length; ipar++) {
                    // Проверяем, является ли значение NaN, чтобы избежать ошибок при его преобразовании в число
                    if (!isNaN(params[ipar].value[1]) && !usedSeriesNames.hasOwnProperty(params[ipar].seriesName)) {
                        output +=
                            params[ipar].marker + params[ipar].seriesName + ': ' + params[ipar].value[1]?.toFixed(3);
                        usedSeriesNames[params[ipar].seriesName] = true;

                        if (ipar != params.length - 1) {
                            output += '<br/>';
                        }
                    }
                }
                return output;
            },
            axisPointer: {
                animation: false
            }
        },
        brush: {
            toolbox: [],
            xAxisIndex: 'all',
            brushLink: 'all',
            outOfBrush: {
                colorAlpha: 0.2
            },
            throttleType: 'debounce'
        },
        xAxis: {
            type: 'time',
            silent: false,
            splitNumber: 20,
            axisLine: {
                show: false
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#ecedee'
                }
            },
            axisTick: {
                show: false
            },
            splitArea: {
                show: false
            }
        },
        animation: false
    } as unknown as EChartOption;

    const [option, setOption] = React.useState<EChartOption>({});

    React.useEffect(() => {
        const getOption = () => {
            let getOldOption = option;

            let newOption = option.grid ? getOldOption : option_def;

            let seriesall: any[] = [];
            let yAxisArr: any = [];

            let AxisIndex: number[] = [];

            const dataZoomArr: EChartOption.DataZoom[] = [
                {
                    type: 'inside',
                    realtime: true,
                    start: 0,
                    end: 100
                },
                {
                    type: 'slider',
                    fillerColor: 'rgba(255, 255, 255, 0.4)',
                    borderColor: 'rgba(255, 255, 255, 1)',
                    handleSize: '0%',
                    moveHandleIcon: 'none',
                    moveHandleSize: 5,
                    moveHandleStyle: {
                        color: '#dfdfdf'
                    },
                    emphasis: {
                        moveHandleStyle: {
                            color: '#dfdfdf'
                        }
                    },
                    showDetail: false,
                    showDataShadow: false,
                    height: 0,
                    start: 0,
                    end: 100,
                    bottom: '3%'
                }
            ] as unknown as EChartOption.DataZoom[];

            let colors: string[] = [];

            let namesLegend = [];

            let formatterData = function (a: any) {
                return a.toFixed(1).toLocaleString();
            };

            for (let i = 0; i < props.pens.length; i++) {
                // if (props.pens[i].name != '') {
                let seriestemp = JSON.parse(JSON.stringify(dataline));

                let name = props.pens[i].name;

                if (props.data[name] && props.pens[i].selected) {
                    seriestemp.data = props.data[name];
                } else {
                    seriestemp.data = [];
                }

                seriestemp.name = props.pens[i].name;

                namesLegend.push(name);

                seriestemp.lineStyle = {
                    ...seriestemp.lineStyle,
                    color: props.pens[i].color
                };

                colors.push(props.pens[i].color);

                if (props.pens[i].selected) {
                    seriestemp.lineStyle.width = 3;
                    seriestemp.symbolSize = 4;
                }

                seriestemp.yAxisIndex = props.pens[i].yAxisIndex != null ? props.pens[i].yAxisIndex : yAxisArr.length;
                AxisIndex.push(seriestemp.yAxisIndex);

                seriesall.push(seriestemp);

                if (props.pens[i].typeLine != 'radar' && seriestemp.yAxisIndex == yAxisArr.length) {
                    let showAxis = false;

                    if (props.selectedPen == props.pens[i].name) {
                        showAxis = true;
                    }

                    let formatterY = formatterData;
                    let yAxis = {
                        type: 'value',
                        min: Number(props.pens[i].min),
                        max: Number(props.pens[i].max),
                        splitNumber: 11,
                        axisLabel: {
                            fontSize: 12,
                            fontWeight: 200,
                            formatter: formatterY
                        },
                        axisLine: {
                            show: false,
                            lineStyle: {
                                color: props.pens[i].color
                            }
                        },
                        splitLine: {
                            interval: 4,
                            lineStyle: {
                                color: '#ecedee'
                            }
                        },
                        show: showAxis ? true : false,
                        position: 'left',
                        animation: false,
                        offset: 0
                    };

                    yAxisArr.push(yAxis);
                } else {
                    yAxisArr[seriestemp.yAxisIndex].min = Math.min(
                        yAxisArr[seriestemp.yAxisIndex].min,
                        Number(props.pens[i].min)
                    );
                    yAxisArr[seriestemp.yAxisIndex].max = Math.max(
                        yAxisArr[seriestemp.yAxisIndex].max,
                        Number(props.pens[i].max)
                    );
                }
                // }
            }

            let typeX =
                (props.config.settings.chart.xAxis as IAxisSetting) != undefined
                    ? ((props.config.settings.chart.xAxis as IAxisSetting).type as any)
                    : 'time';

            let formatterX = undefined;
            if (typeX != 'time') {
                formatterX = formatterData;
            }

            if ((props.config.settings.chart.xAxis as IAxisSetting)?.name) {
                if (newOption.grid) {
                    let name = (props.config.settings.chart.xAxis as IAxisSetting)?.name;
                    let nameLength = name?.length;
                    let rightValue = 25;

                    if (nameLength) {
                        rightValue += nameLength * 6;
                    }

                    newOption.grid = {
                        right: rightValue
                    };
                }
            }

            newOption = {
                ...newOption,
                color: colors,
                toolbox: {
                    show: false
                },
                grid: {
                    ...newOption.grid
                },
                radar: props.config.settings.chart.radar,
                xAxis: {
                    ...newOption.xAxis,
                    axisLabel: {
                        color: '#dadada',
                        fontWeight: 300,
                        formatter: formatterX
                    },
                    name: (props.config.settings.chart.xAxis as IAxisSetting)?.name,
                    min: (props.config.settings.chart.xAxis as IAxisSetting)?.min,
                    max: (props.config.settings.chart.xAxis as IAxisSetting)?.max,
                    type: typeX
                },
                dataZoom: dataZoomArr,
                yAxis: yAxisArr,
                series: seriesall
            };

            return newOption;
        };

        let options = getOption();

        setOption(options);
    }, [props.resetData]);

    //Обновление серий
    React.useEffect(() => {
        const echartsInstance = refs.chartRef?.current.getEchartsInstance();
        const currentOptions = echartsInstance.getOption();

        if (currentOptions.series.length != 0) {
            props.pens.forEach((pen, i) => {
                if (pen.selected) {
                    currentOptions.series[i].data = props.data[pen.name];
                    currentOptions.series[i].name = pen.name;
                    currentOptions.yAxis[i].min = +pen.min;
                    currentOptions.yAxis[i].max = +pen.max;
                } else {
                    currentOptions.series[i].data = [];
                }
            });
        }

        echartsInstance.setOption(currentOptions, { notMerge: true });
    }, [props.pens]);

    React.useEffect(() => {
        const echartsInstance = refs.chartRef?.current.getEchartsInstance();
        let currentOptions = echartsInstance.getOption();

        if (currentOptions.series.length != 0) {
            for (let i = 0; i < props.pens.length; i++) {
                if (props.selectedPen == props.pens[i].name) {
                    if (props.pens[i].max) {
                        const scale = props.pens[i].max.toString().split('.')[0].length - 3;

                        currentOptions.grid[0].left = 45 + scale * 5;
                    } else {
                        currentOptions.grid[0].left = 45;
                    }
                }
            }
        }

        echartsInstance.setOption(currentOptions);
    }, [props.pens, props.selectedPen]);

    //Обновление оси для выбранного пена
    React.useEffect(() => {
        const echartsInstance = refs.chartRef?.current.getEchartsInstance();
        let currentOptions = echartsInstance.getOption();

        if (props.selectedPen) {
            for (let i = 0; i < props.pens.length; i++) {
                if (currentOptions.yAxis && currentOptions.xAxis) {
                    if (props.selectedPen == props.pens[i].name) {
                        if (currentOptions.yAxis[i]) currentOptions.yAxis[i].show = true;
                    } else {
                        if (currentOptions.yAxis[i]) currentOptions.yAxis[i].show = false;
                    }
                }
            }
        }

        echartsInstance.setOption(currentOptions, { notMerge: true });
    }, [props.selectedPen]);

    return (
        <ReactEcharts
            //   notMerge={props.notMerge}
            notMerge={true}
            lazyUpdate={true}
            option={option}
            // onEvents={onEvents}
            style={{ height: '100%', width: '100%' }}
            ref={refs.chartRef}
            opts={{ locale: '' }}
        />
    );
});

export default GroupGraph;
